import { Link } from "react-router-dom";

export const LogoMark = ({ size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" aria-hidden="true">
    <defs>
      <linearGradient id="lm-g" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#08A881" />
        <stop offset="1" stopColor="#065A4A" />
      </linearGradient>
      <linearGradient id="lm-r" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0" stopColor="#EAF9F9" />
        <stop offset="1" stopColor="#7FE8D3" />
      </linearGradient>
    </defs>
    <rect width="48" height="48" rx="13" fill="url(#lm-g)" />
    <rect x="13" y="9" width="20" height="13" rx="3" fill="#EAF9F9" opacity="0.9" transform="rotate(-8 23 15)" />
    <path d="M9 19h30a3 3 0 0 1 3 3v14a4 4 0 0 1-4 4H12a4 4 0 0 1-4-4V20a1 1 0 0 1 1-1Z" fill="#0B6A57" stroke="url(#lm-r)" strokeWidth="1.6" />
    <path d="M20 29.5l3 3 6-6.5" fill="none" stroke="#EAF9F9" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const Logo = ({ light = false, testid = "logo-link" }) => (
  <Link to="/" className="flex items-center gap-2.5 shrink-0" data-testid={testid}>
    <LogoMark />
    <span className={`font-display text-[1.15rem] font-semibold tracking-tight ${light ? "text-white" : "text-ww-navy"}`}>
      Warranty <span className={light ? "text-[#7FE8D3]" : "text-ww-emerald"}>Wallet</span>
    </span>
  </Link>
);
